// extracted by mini-css-extract-plugin
module.exports = {"app":"App_app__1tA9O","header":"App_header__14Wxn","main":"App_main__jNC5T"};